<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset-y
    :top="openUpwards"
    :bottom="!openUpwards"
    left
    nudge-left="35"
    min-width="450"
    content-class="comment-menu-content elevation-8"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        :content="unreadCount"
        :value="unreadCount > 0"
        color="red"
        overlap
        class="comment-activator ml-1 mr-1"
      >
        <v-btn
          icon
          small
          v-bind="attrs"
          v-on="on"
          @mousedown="calculateDirection"
          class="grey--text text--darken-1"
          :class="{ 'primary--text': menuOpen || unreadCount > 0 }"
        >
          <v-icon small>mdi-comment-text-outline</v-icon>
        </v-btn>
      </v-badge>
    </template>

    <comment-popover
      :project-id="projectId"
      :field-id="fieldId"
      :field-name="fieldName"
      v-if="menuOpen"
      @close="menuOpen = false"
    ></comment-popover>
  </v-menu>
</template>

<script>
import CommentPopover from './CommentPopover.vue';

export default {
  name: 'FieldCommentIndicator',
  components: {
    CommentPopover
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true
    },
    fieldId: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuOpen: false,
      openUpwards: false
    };
  },
  watch: {
    menuOpen(val) {
      if (!val) {
        // Reset or additional logic if needed when closing
      }
    }
  },
  methods: {
    calculateDirection(e) {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (e && e.clientY) {
        this.openUpwards = e.clientY > (windowHeight / 2);
      } else if (this.$el) {
        const rect = this.$el.getBoundingClientRect();
        this.openUpwards = rect.top > (windowHeight / 2);
      }
    }
  },
  computed: {
    comments() {
      return this.$store.getters['projetos/getFieldComments'](this.fieldId) || [];
    },
    unreadCount() {
      return this.comments.filter(c => c.status === 'aberto').length;
    }
  }
};
</script>

<style scoped>
.comment-activator {
  /* Alinhamento refinado para combinar com outras actions da label do vuetify */
  margin-top: 1px;
}
</style>
<style>
/* Unscoped to pierce Vuetify's detached DOM menus */
.comment-menu-content {
  z-index: 200 !important;
}
</style>
